import React, { useEffect, useCallback, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from 'semantic-ui-react';
import { inject, observer } from 'mobx-react';
import ErrorBoundary from 'components/common/error-boundary';
import { NEW_ROUTE_PREFIX, MOBILE_BREAKPOINT } from 'utils/constants';
import SubHeader from 'components/common/sub-header';
import General from './general';

const IngredientCategoryEditor = inject(
  'IngredientCategoryEditor',
  'Notification',
  'IngredientCategory',
)(
  observer(({ IngredientCategoryEditor, Notification, match, admin }) => {
    const { save, edit, clearValidation } = IngredientCategoryEditor;

    const ingredientCategoryId = match.params && match.params.id;
    const isEdit = ingredientCategoryId && ingredientCategoryId !== NEW_ROUTE_PREFIX;
    const [disabled, setDisabled] = useState(false);

    useEffect(() => {
      if (isEdit) {
        edit(ingredientCategoryId);
      }
      return () => {
        clearValidation();
      };
    }, []);

    const header = isEdit ? (
      <FormattedMessage id="ingredient-category.edit" defaultMessage="Edit ingredient category" />
    ) : (
      <FormattedMessage
        id="ingredient-category.create"
        defaultMessage="Create ingredient category"
      />
    );

    const submitForm = useCallback(async () => {
      setDisabled(true);

      await save({ admin, isEdit }).catch(e => {
        Notification.showError(e.message);
      });
      setDisabled(false);
    }, []);

    const isMobile = window.innerWidth < 1136;
    const width = window.innerWidth;
    const desktop = width >= MOBILE_BREAKPOINT;

    return (
      <form className="ui form">
        <SubHeader
          title={header}
          button={
            <Button
              type="button"
              primary
              disabled={disabled}
              onClick={submitForm}
              style={{ minWidth: isMobile ? 0 : 180 }}
            >
              <FormattedMessage id="buttons.save" />
            </Button>
          }
        />
        <ErrorBoundary>
          <General desktop={desktop} isEdit={isEdit} />
        </ErrorBoundary>
      </form>
    );
  }),
);

export default IngredientCategoryEditor;
